import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useDeleteBookingVoucher(
  bookingCode: string,
  voucherCode?: string
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: !!voucherCode
      ? async () =>
          apiMutation('DELETE', {
            path: ENDPOINTS.updateOrDeleteBookingVoucher,
            params: { bookingCode, voucherCode },
          }) as Promise<void>
      : async () => {
          /* no-op */
        },
    onSuccess: () => {
      message.success('Voucher deleted');

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.booking, { code: bookingCode }],
      });
    },
    onError: () => {
      message.error('Failed to delete voucher');
    },
  });
}
